var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrimaryHearthSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.88735 10.207H10.2071V7.8872L9.2792 0L8.81525 0L7.88735 7.83152V10.207Z",
    fill: "#040626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04722 10.2671L10.2628 9.04692L9.04722 7.83136L4.41697 4.17542L4.17571 4.42131L7.79918 9.01908L9.04722 10.2671Z",
    fill: "#040626"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.82696 9.04704L9.04715 10.2672L10.2627 9.04704L13.9187 4.42143L13.6728 4.17554L9.07499 7.79901L7.82696 9.04704Z",
    fill: "#040626"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04715 7.83148L7.82696 9.04704L9.04715 10.2626L13.6774 13.9185L13.9187 13.6726L10.2952 9.07488L9.04715 7.83148Z",
    fill: "#040626"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2628 9.04704L9.04722 7.83148L7.83166 9.04704L4.17571 13.6773L4.42161 13.9185L9.01938 10.2951L10.2628 9.04704Z",
    fill: "#040626"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.88723 7.88708V10.2068H10.207L18.0942 9.27894V8.81499L10.2627 7.88708H7.88723Z",
    fill: "#040626"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2071 7.88708H7.88735V10.2068L8.81525 18.094H9.2792L10.2071 10.2625V7.88708Z",
    fill: "#040626"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2071 10.2068V7.88708H7.88735L0.000148218 8.81499V9.27894L7.83167 10.2068H10.2071Z",
    fill: "#040626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryHearthSymbol);
export default __webpack_public_path__ + "static/media/primary_hearth_symbol.940e6b234f44e9cf633ba5a8ee8f3572.svg";
export { ForwardRef as ReactComponent };